import { request } from '../../api/client';
import type { FolderLocation } from '../files/explorerApi';

export type BoardKind = 'asset' | 'project';
export interface BoardAvatar { attachmentId: number | null; preview: string; original: string; canEdit: boolean }
export interface ProjectCard extends BoardAvatar { id: number; title: string; hasFolder: boolean }
export const avatarKey = (kind: BoardKind, id: number) => ['board-avatar', kind, id] as const;
export const boardAvatarApi = {
  get: (kind: BoardKind, id: number) => request<BoardAvatar>(`/api/${kind}s/${id}/avatar`),
  save: (kind: BoardKind, id: number, attachmentId: number, previousId: number | null) =>
    request<BoardAvatar>(`/api/${kind}s/${id}/avatar`, { method: 'PUT', body: { attachmentId, previousId } }),
  projects: () => request<ProjectCard[]>('/api/projects/cards'),
  project: (id: number) => request<ProjectCard>(`/api/projects/${id}`),
  folder: (id: number, signal?: AbortSignal) => request<FolderLocation & { name: string; server: string }>(`/api/projects/${id}/folder`, { signal }),
};
